import { resolveApiErrorMessage } from "@/lib/errors/resolveApiErrorMessage";

/**
 * GraphQL contract from `mapBillingPastDueError` / `BillingPastDueError`.
 * Production GraphQL used to mask this as "Internal Server Error".
 */
export const SUBSCRIPTION_PAST_DUE_ERROR_MARKER = "SUBSCRIPTION_PAST_DUE";

function collectErrorMessages(error: unknown): string[] {
  if (!error) return [];
  if (typeof error === "string") return [error];
  if (typeof error !== "object") return [];

  const messages: string[] = [];
  const e = error as { message?: unknown; graphQLErrors?: Array<{ message?: unknown }> };
  if (typeof e.message === "string") messages.push(e.message);
  if (Array.isArray(e.graphQLErrors)) {
    for (const gqlError of e.graphQLErrors) {
      if (gqlError && typeof gqlError.message === "string") {
        messages.push(gqlError.message);
      }
    }
  }
  const apiMessage = resolveApiErrorMessage(error);
  if (apiMessage) messages.push(apiMessage);
  return messages;
}

export function isSubscriptionPastDueError(error: unknown): boolean {
  return collectErrorMessages(error).some((message) => (
    message.includes(SUBSCRIPTION_PAST_DUE_ERROR_MARKER)
  ));
}
